const SKILL_KEYS = ['apply.py', 'acquire.py', 'safe_state.py', 'plog.py', 'env_check.py']

function isSkillCommand(cmd = '') {
  const low = String(cmd).toLowerCase()
  return SKILL_KEYS.some((k) => low.includes(k))
}

function firstSentence(text, max = 80) {
  const s = String(text || '').replace(/\s+/g, ' ').trim()
  if (!s) return ''
  const cut = s.split(/。|！|？|\. |! |\? /)[0]
  const use = cut && cut.length < s.length ? `${cut}` : s
  return use.length > max ? `${use.slice(0, max)}…` : use
}

function bashCmd(msg) {
  const input = msg.toolInput || {}
  return input.command || input.cmd || ''
}

export function messagesToArchive(messages = [], meta = {}) {
  const events = []
  let seq = 0
  const push = (actor, kind, tier, payload) => {
    seq += 1
    events.push({
      seq,
      ts: new Date().toISOString(),
      task_id: '',
      actor,
      kind,
      tier,
      payload,
    })
  }
  ;(messages || []).forEach((msg) => {
    switch (msg.type) {
      case 'user_input': {
        const text = msg.content || ''
        if (text.startsWith('[选择]')) {
          push('student', 'answer', 'A', { answers: text })
        } else {
          push('student', 'say', 'A', { text })
        }
        break
      }
      case 'text':
      case 'result':
        if (msg.content) push('youlaber', 'text', 'A', { text: msg.content })
        break
      case 'thinking':
        if (msg.content) push('youlaber', 'think', 'B', { text: msg.content })
        break
      case 'tool_use': {
        const name = msg.toolName || ''
        const cmd = bashCmd(msg)
        if (name === 'Bash' && isSkillCommand(cmd)) {
          push('tool', 'command', 'A', { tool: name, command: cmd })
        } else {
          push('tool', 'command', 'B', {
            tool: name,
            path: msg.toolInput?.file_path || msg.toolInput?.path || '',
          })
        }
        break
      }
      case 'tool_result': {
        const text = msg.content || ''
        const kind = msg.isError || /ERROR|WARN|abort/i.test(text) ? 'anomaly' : 'output'
        push('tool', kind, 'A', { text, is_error: !!msg.isError })
        break
      }
      case 'agent_turn':
        push(`role:${msg.agentName || ''}`, 'discuss', 'A', {
          subagent_type: msg.agentName || '',
          prompt: msg.promptText || '',
          reply: msg.reply || '',
        })
        break
      case 'workspace_file_link':
        push('youlaber', 'artifact', 'A', { path: msg.path, name: msg.name })
        break
      case 'system_note':
        push('youlaber', 'note', 'B', { text: msg.content || '' })
        break
      default:
        break
    }
  })
  return {
    meta: {
      schema: 'youlaber-chatlog/1',
      exported_at: new Date().toISOString(),
      source: 'gui-memory',
      ...meta,
      counts: {
        student_turns: events.filter((e) => e.kind === 'say').length,
        commands: events.filter((e) => e.kind === 'command' && e.tier === 'A').length,
        discussions: events.filter((e) => e.kind === 'discuss').length,
      },
    },
    events,
  }
}

export function archiveToMarkdown(doc) {
  const meta = doc.meta || {}
  const date = String(meta.exported_at || '').slice(0, 10)
  const lines = [
    `# YouLabber 实验对话 ${meta.device_type || ''} ${date}`,
    '',
    `> **Workspace:** ${meta.cwd || ''}`,
    '',
    '| 项 | 值 |',
    '|---|---|',
    `| schema | ${meta.schema || ''} |`,
    `| source | ${meta.source || ''} |`,
    `| student_id | ${meta.student_id || ''} |`,
    '',
  ]
  let heading = ''
  const flush = (h) => {
    if (heading !== h) {
      lines.push('', `## ${h}`, '')
      heading = h
    }
  }
  ;(doc.events || []).forEach((e) => {
    const p = e.payload || {}
    switch (e.kind) {
      case 'say':
        flush('User')
        lines.push(p.text || '')
        break
      case 'answer':
        flush('User')
        lines.push(String(p.answers || ''))
        break
      case 'command':
        flush('Assistant')
        lines.push('### 执行', '')
        if (e.tier === 'A') {
          lines.push('```bash', p.command || '', '```', '')
        } else {
          lines.push(`\`${p.tool || ''}\` ${p.path || ''}`, '')
        }
        break
      case 'output':
      case 'anomaly':
        flush('Assistant')
        lines.push(e.kind === 'anomaly' ? '⚠' : '', '```text', p.text || '', '```', '')
        break
      case 'discuss':
        flush('Assistant')
        lines.push(`### 研讨 【${p.subagent_type || ''}】`, '', p.prompt || '', '', p.reply || '', '')
        break
      case 'text':
        flush('Assistant')
        lines.push('### 回复', '', p.text || '', '')
        break
      case 'think':
      case 'note':
        flush('Assistant')
        lines.push('### 思考摘要', '', `[思考摘要] ${firstSentence(p.text)}`, '')
        break
      case 'artifact':
        flush('Assistant')
        lines.push('### 产物', '', `- [${p.name || p.path}](${p.path})`, '')
        break
      default:
        break
    }
  })
  return lines.join('\n')
}

export function toJSON(messages, meta) {
  return JSON.stringify(messagesToArchive(messages, meta), null, 2)
}

export function toMarkdown(messages, meta) {
  return archiveToMarkdown(messagesToArchive(messages, meta))
}

export function downloadText(filename, text, mime = 'text/plain') {
  const blob = new Blob([text], { type: `${mime};charset=utf-8` })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

export function markdownFileFromText(text, name = 'chatlog.md') {
  return new File([text], name, { type: 'text/markdown' })
}
